import { Component, For, createEffect, on, untrack } from 'solid-js'
import { StateMapDisk } from '../lib/core/state/state_map_disk.enum'
import { hasCloud } from '../lib/core/has_cloud'
import { hasIndexedDB } from '../lib/core/Storage/IndexedDB/hasIndexedDB'

interface Props {
  id?: string
  value: StateMapDisk
  onChange: (value: StateMapDisk) => void
  localStorageKey?: string
  allowWorkspace?: boolean
}

type DiskOption = {
  label: string
  value: StateMapDisk
  disabled?: boolean
  title?: string
}

const DiskSelect: Component<Props> = (props) => {
  const allowWorkspace = untrack(() => props.allowWorkspace === true)
  const hasIndexedDBFeature = hasIndexedDB()
  const supportedDisks = [
    ...(hasCloud ? [{ label: 'Cloud', value: StateMapDisk.Cloud }] : []),
    ...(hasIndexedDBFeature ? [{ label: 'IndexedDB (Offline)', value: StateMapDisk.IndexedDB }] : []),
    ...(allowWorkspace && import.meta.env.DEV ? [{ label: 'Workspace (Dev)', value: StateMapDisk.Workspace }] : []),
  ]
  if (!supportedDisks.length) {
    throw new Error('No supported disks available (IndexedDB, Cloud, or Workspace required)')
  }

  const diskOptions: DiskOption[] = [
    ...supportedDisks,
    {
      label: 'Export (Future file save/load)',
      value: StateMapDisk.Export,
      disabled: true,
      title: 'Future file save/load',
    },
  ]

  createEffect(on(() => props.value, (val) => {
    if (props.localStorageKey && val !== StateMapDisk.Export) {
      localStorage.setItem(props.localStorageKey, val)
    }
  }))

  return (
    <div class="mb-3 d-flex align-items-center">
      <label class="me-2" for={props.id}>Storage:</label>
      <select
        id={props.id}
        class="form-select form-select-sm w-auto"
        value={props.value}
        onChange={(e) => props.onChange(e.currentTarget.value as StateMapDisk)}
      >
        <For each={diskOptions}>
          {(disk) => (
            <option value={disk.value} disabled={disk.disabled} title={disk.title}>
              {disk.label}
            </option>
          )}
        </For>
      </select>
    </div>
  )
}

export default DiskSelect
